import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';

const FASTAPI_URL = process.env.REACT_APP_API_URL;

const ManageConnection = () => {
    const { userId } = useParams();
    const navigate = useNavigate();
    const [connectionStatus, setConnectionStatus] = useState(null);
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(true);

    // Fetch connection status on component mount
    useEffect(() => {
        const fetchConnectionStatus = async () => {
            try {
                const response = await axios.get(`${FASTAPI_URL}/api/connection-status/${userId}`);
                setConnectionStatus(response.data.connection_status);
            } catch (err) {
                console.error('Error fetching connection status:', err);
                setError('Failed to fetch connection status. Please try again.');
            } finally {
                setLoading(false);
            }
        };

        fetchConnectionStatus();
    }, [userId]);

    // Handle disconnect button click
    const handleDisconnect = async () => {
        setError('');
        try {
            setLoading(true);
            await axios.delete(`${FASTAPI_URL}/api/user/${userId}/instances`);
            setConnectionStatus(false); // Update the status after disconnecting
        } catch (err) {
            console.error('Error disconnecting:', err);
            setError('Failed to disconnect. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return <p>Loading...</p>;
    }

    return (
        <div>
            <h1>Manage Connection</h1>
            {error && <p style={{ color: 'red' }}>{error}</p>}
            <p>
                <strong>Connection Status:</strong> {connectionStatus ? 'Connected' : 'Disconnected'}
            </p>
            {connectionStatus && (
                <button onClick={handleDisconnect} disabled={loading}>
                    Disconnect
                </button>
            )}
            <button onClick={() => navigate('/')} style={{ marginLeft: '10px' }}>
                Back to Home
            </button>
        </div>
    );
};

export default ManageConnection;
